module.exports = __webpack_public_path__ + "img/downloadLogo.png";